import "./number-keyboard.css";
import { NumberKeyboard } from './number-keyboard';
export default NumberKeyboard;